import React from "react";
import axios from "axios";
import { backend } from "../../../../backend";
import AdCard from "../../../AdPage/AdCard/AdCard";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./similarAds.css";
import InterestCard from "../../../AdPage/InterestCard/InterestCard";
import RoundedLinkButton from "../../../../components/Buttons/RoundedLinkButton/RoundedLinkButton";
import RoundedButton from "../../../../components/Buttons/RoundedButton/RoundedButton";

function SimilarAds() {
  const { id } = useParams();
  const [similarAds, setSimilarAds] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3);

  useEffect(() => {
    const fetchSimilarAds = async () => {
      try {
        const response = await axios.get(
          backend(`/api/listings/similar?id=${id}`),
        );
        setSimilarAds(response.data.ads);
      } catch (error) {
        console.error("Kunde inte hämta liknande lokaler", error);
      }
    };

    if (id) {
      fetchSimilarAds();
    }
  }, [id]);

  return (
    <section className="similar-ads-section">
      <h2>Liknande lokaler</h2>

      {/* Inga liknande lokaler */}
      {similarAds.length === 0 && (
        <div className="no-similar-ads">
          <p>Tyvärr verkar det inte finnas några liknande lokaler just nu...</p>
          <p>
            Skicka in en lokalförfrågan så letar vi upp en lokal åt er -
            kostnadsfritt!
          </p>
          <RoundedLinkButton
            href={"/lokalforslag"}
            label={"Få gratis lokalförslag"}
            color="green"
            size="lg"
          />
        </div>
      )}

      {/* Finns liknande lokaler */}
      {similarAds.length > 0 && (
        <>
          <ul className="similar-ads-list">
            {similarAds.slice(0, visibleCount).map((ad) => (
              <li className="ad-similar" key={ad._id}>
                <AdCard key={ad._id} id={ad} />
              </li>
            ))}

            {/* Om det bara finns 1 → fyll ut med InterestCard */}
            {similarAds.length === 1 && (
              <li className="ad-similar">
                <InterestCard />
              </li>
            )}
          </ul>

          {/* Visa mer-knapp */}
          {visibleCount < similarAds.length && (
            <div className="btn-show-more-similar">
              <RoundedButton
                onClick={() => setVisibleCount((prev) => prev + 3)}
                label={"Visa fler"}
                size="md"
              />
            </div>
          )}
        </>
      )}
    </section>
  );
}

export default SimilarAds;
